/**
 *
 */
import {LoadListenerConfig} from '../types/LoadListenerConfig';
import FontFaceObserver from 'fontfaceobserver';


/**
 *
 */
export default class LoadListener
{
	/**
	 *
	 * @private
	 */
	private config: LoadListenerConfig;


	/**
	 *
	 * @param {LoadListenerConfig} config
	 */
	public constructor( config: LoadListenerConfig )
	{
		this.config = config;

		this.setupOnLoad();
	}


	/**
	 * add css classes to the HTML element after different loading phases, and supply callbacks for each phase
	 *
	 * @private
	 */
	private setupOnLoad()
	{
		document.documentElement.classList.remove( 'no-js' );

		window.addEventListener( 'DOMContentLoaded', () =>
		{
			this.handlePhase( 'dom-content', this.config.dom );
		} );

		window.addEventListener( 'load', () =>
		{
			this.handlePhase( 'page', this.config.page );
		} );

		if (typeof this.config.fonts === 'object' && Array.isArray( this.config.fonts.families )) {
			this.setup3rdPartyFontOnload( this.config.fonts.families, this.config.fonts.loaded );
		}
	}


	/**
	 *
	 * @param {string} name
	 * @param {function|null} callback
	 * @private
	 */
	private handlePhase( name: string, callback: Function | null = null )
	{
		document.documentElement.classList.add( `${name}-loaded` );

		if (typeof callback === 'function') {
			callback();
		}
	}


	/**
	 *
	 * @param {string[]} families
	 * @param {function|null} loadedCallback
	 * @private
	 */
	private setup3rdPartyFontOnload( families: Array<string>, loadedCallback: Function | null = null )
	{
		const promises = families.map( family => new FontFaceObserver( family ).load() );

		Promise.all( promises ).then( () =>
		{
			this.handlePhase( 'fonts', loadedCallback );

		} ).catch( err =>
		{
			console.log( 'some fonts could not be loaded:', err );
		} );
	};

}